import * as React from 'react';
import style from '../core.less';
import * as classNames from 'classnames';

interface WSimpleNTupelListProps extends React.ClassAttributes<any> {
    data: Array<any>;
    width?: any;
    fontSize?: number;
}

interface WSimpleNTupelListState {
    dummy?: string;
}
export class WSimpleNTupelList extends React.Component<WSimpleNTupelListProps, WSimpleNTupelListState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    render() {
       return (<div
            className={classNames(style.colContainer, style.tupelList)}
            style={{display: 'flex'}}
           >
           {this.props.data.map((tupel: any, idx: number) =>
                <div
                    key = {'tupel_idx_' + idx}
                    className = {classNames(style.flexItem, style.rowContainer, style.tupelRow)}>
                    {Object.keys(tupel).map((key: string) => {
                         const styleCell: any = this.props.width && this.props.width[key]
                            ? {width: this.props.width[key] + 'px', maxWidth: this.props.width[key] + 'px'}
                            : this.props.width && typeof this.props.width === 'number'
                                ? {width: this.props.width + 'px', maxWidth: this.props.width + 'px'}
                                : {};
                        if (this.props.fontSize) {
                            styleCell.fontSize = this.props.fontSize + 'px';
                        }
                        return (
                            <div
                                key = {'tupel_idx_' + idx + '_' + key}
                                className = {classNames(style.flexItem, key === 'name' ? style.tupelName : style.tupelValue)}
                                style = {styleCell}
                            >
                            {tupel[key]}
                            </div>
                        );
                    })}
                </div>
           )}
       </div>);
    }
}
